import queryString from 'query-string';

import { getCache, setCache } from '@/utils';

const key = 't';

export interface Tracking {
  referrer: string;
  landing: string;
}

export function updateTracking(): void {
  const query = queryString.parse(window.location.search);
  const val = getCache(key);

  if (val && !query.ref) return;

  const tracking: Tracking = {
    referrer: document.referrer,
    landing: window.location.href,
  };

  setCache(key, tracking);
}

export function clearTracking(): void {
  setCache(key, undefined);
}

export function getTracking(): Tracking | undefined {
  return getCache(key);
}
